import React, { Component } from "react";
import PropTypes from 'prop-types';

import Ava from "../../../assets/images/avatar-none.png"
import "./Avatar.scss";

class Avatar extends Component {
  static propTypes = {
    avatar: PropTypes.object,
  };

  static defaultProps = {
    avatar: null,
  };

  render() {
    const { avatar } = this.props;
    const srcPreview = (avatar && avatar.preview) ? avatar.preview : Ava;
    const src = avatar && avatar.url ? avatar.url : null;

    const bgStyle = {
      backgroundImage:` url(${src})`,
      backgroundSize: 'cover',
    };

    return (
      <div className="ava-wrap">
        <div className="ava-img-wrap">
          <img src={srcPreview} alt="" />
        </div>
        {src !== null ? (
        <div className="ava-popup" style={bgStyle}>
          
        </div>
        ) : false}
      </div>
    );
  }
}

export default Avatar;
